import {Assignment} from './assignment.model';
import {CrudService} from '@ngx-ivengi/crud';

export class AssignmentService extends CrudService<Assignment> {
  public entityType = Assignment;
}



// WEBPACK FOOTER //
// /var/jenkins_home/workspace/brands-compart-portal-frontend/checkout/src/app/components/assignment/assignment.service.ts